export class PracticeDocument {
  id: number;
  praticaId: number;
  tipologiaDocumentoPratica: string;
  file: File;
}
